import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import moment from 'moment'
import EmployeeConfig from '../../../../services/api/EmployeeConfig'

const { Employee_Notifications_Center_Endpoints } = EmployeeConfig
const SELF_BFF_API = process.env.REACT_APP_SELF_BFF_BASE_URL

const resetState = {
  pageNumber: 0,
  activeFilters: {
    headers: [],
    date: [],
  },
  activeSearch: '',
  activeSort: {},
  updatedItem: {},
}

export const notificationCenterResetAlertHandler = createAsyncThunk(
  'notificationCenter/notificationCenterResetAlertHandler',
  async () => ({}),
)
export const getNotificationsListWithQueries = createAsyncThunk(
  'notificationCenter/getNotificationsList',
  async ({ queries, resetQueries }, { rejectWithValue, getState }) => {
    const { notificationCenter } = getState()
    const apiUri = Employee_Notifications_Center_Endpoints()

    const queryObj = createReqHelper(notificationCenter, resetQueries ? resetState : queries)

    const response = await axios.get(`${SELF_BFF_API}/${apiUri.notificationsCenterList}`, { params: queryObj })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return {
      response: response.data,
      queries: resetQueries ? resetState : queries,
    }
  },
)

export const getNotificationsCenterBell = createAsyncThunk(
  'notificationCenter/getNotificationsCenterBell',
  async (_, { rejectWithValue }) => {
    const apiUri = Employee_Notifications_Center_Endpoints()
    const response = await axios.get(`${SELF_BFF_API}/${apiUri.notificationCenterBell}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

function removeFilterIfExist(queries, activeFilters) {
  if ('startDate' in queries) {
    return {
      headers: activeFilters.headers,
      date: [],
    };
  }
  activeFilters.headers =
  activeFilters.headers.filter((singleFilter) => singleFilter.id !== queries.id)

  return activeFilters
}

export const filterNotificationsCenterList = createAsyncThunk(
  'notificationCenter/filterNotificationsCenterList',
  async ({ queries }, {
    getState,
    rejectWithValue,
  }) => {
    const { notificationCenter } = getState()
    const apiUri = Employee_Notifications_Center_Endpoints()
    let newFilterObj = { ...notificationCenter?.activeFilters }

    if (queries === 'clear') {
      newFilterObj = {
        headers: [],
        date: [],
      }
    } else if ('headers' in queries) {
      newFilterObj = queries
    } else {
      newFilterObj = removeFilterIfExist(queries, newFilterObj)
    }

    const queryObj = createReqHelper(notificationCenter, { activeFilters: newFilterObj })

    const response = await axios.get(`${SELF_BFF_API}/${apiUri.notificationsCenterList}`, { params: queryObj })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      filters: newFilterObj,
    }
  },
)

function createReqHelper(store, filters = {}) {
  const copyStore = { ...store, ...filters }

  const {
    activeSearch,
    pageSize,
    activeSort,
    pageNumber,
    activeFilters,
  } = copyStore

  const getFilterIds = (filtersId) => (filtersId || []).map((filter) => filter.name)
  const filterHeaders = getFilterIds(activeFilters?.headers)?.join(',')

  const getFormateDate = (FilterDate) => (FilterDate ? moment(FilterDate).locale('en').format('YYYY-MM-DD') : '')

  const from = getFormateDate(activeFilters?.date?.[0]?.startDate)
  const to = getFormateDate(activeFilters?.date?.[0]?.endDate)

  const response = {
    search: activeSearch,
    page_number: pageNumber || 0,
    page_size: pageSize || 9,
    sort_by: activeSort?.key || '',
    headers: filterHeaders,
    from,
    to,
  }

  return response
}
